export default {
    user: {
        name: '',
        email: '',
        password: '',
        designation: '',
    },

    hr: {
        has_hr: '1',
        email: ''
    },

    team_members: '',

    progress: 0,

    offices: [],

    company: {
        id: '',
        name: '',
        employee_count: 10,
        country: '',
        city: '',
        work_from_home: '1',
        travel: '1',
        visitors: '1',
        events: '1',
        other_remarks: '',
        logo: '',
        logo_src: '',
        photo_checkin: null,
    },

    remote_measures: {
        video_conference: true,
        project_management: true,
        clear_sop: true,
        set_communications_protocol: true,   // maps to the shared cloud storage question
        help_remote_ready: true,
        schedule_regular_scrums: false,
        uses_git: false,
        has_tech_team: true,
    },

    validator: {
        user: false,
        company: false,
    },

    setValidator(key, value) {
        this.validator[key] = value;
    },

    validateSignUp() {
        return !!this.user.email && !!this.user.password && !!this.user.designation;
    },

    validateUserName() {
        return this.user.name;
    },

    validateEmail() {
        return this.checkEmailFormat(this.user.email);
    },

    validatePassword() {
        return this.user.password.length >= 8;
    },

    validateCompanyName() {
        return !this.companyNameExists && !!this.company.name;
    },

    validateEmployeeCount() {
        return this.company.employee_count > 0;
    },

    validateCompanyLogo() {
        return this.company.logo;
    },

    validateHrEmail() {
        if (this.hr.has_hr === '1') {
            return this.checkEmailFormat(this.hr.email);
        }

        return true;
    },

    checkEmailFormat(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return re.test(String(email).toLowerCase());
    },
}
